import { store } from '@/decorators/store';
import { SpecialStatus } from '@/entities/SpecialStatus';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'SpecialStatusStore' })
export class SpecialStatusStore extends AbstractEntityStore<SpecialStatus> {
  protected entityIdKey = 'id';
  protected entityValueKey = 'name';
}
